import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MediaComponent } from 'src/app/view/media/media.component';
import { SharedModule } from '../shared/shared.module';
import { RouterModule } from '@angular/router';



@NgModule({
  declarations: [
    MediaComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule.forChild([
      {path:'',component:MediaComponent}
    ])
  ]
})
export class MediaModule { }
